<template>
  <div class="order-list-box" v-loading.fullscreen.lock="fullAllscreenLoading">
    <el-form class="toolbar" :inline="true" size="small">
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="params.BeginTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="params.EndTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择结束日期">
        </el-date-picker>
      </el-form-item>
      <!--<el-form-item label="状态" id="OrderStatus">-->
        <!--<el-select v-model="SearchOrderStatus" placeholder="请选择状态">-->
          <!--<el-option-->
            <!--v-for="(item,key) in OrderStatusNew"-->
            <!--:key="key"-->
            <!--:label="item.label"-->
            <!--:value="item.value">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="关键字">
        <el-input v-model="params.Keyword" placeholder="请输入关键字" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="listSearch" size="mini">查询</el-button>
    </el-form>
    <el-tabs v-model="params.OrderStatus" type="card" @tab-click="handleClick">
      <el-tab-pane :label="'全部'" name="All"></el-tab-pane>
      <el-tab-pane :label="'待支付'" name="WaitPay"></el-tab-pane>
      <el-tab-pane :label="'生效中'" name="Waiting"></el-tab-pane>
      <el-tab-pane :label="'提货中'" name="Lading"></el-tab-pane>
      <el-tab-pane :label="'订单完成'" name="Finish"></el-tab-pane>
      <el-tab-pane :label="'已关闭'" name="Close"></el-tab-pane>
    </el-tabs>
    <!--    订单页面-->
    <div class="orderDetail" v-for="(item,index) in order" :key="index" v-if="!empty">
      <div>
        <div style="display: flex;justify-content: space-between;padding: 0 10px 15px 10px;
">
          <span style="font-size: 14px;color: #797979">订单号:{{ item.OrderId }}{{item.ContractCode?`(${item.ContractCode})`:''}}</span>
          <div>
            <span style="font-size: 14px;color: #797979">订单截止时间:
                  <span style="color: #000000;font-weight: bold">{{ item.DeadLineTime | dateNoT }}</span>
              </span>
             <span style="font-size: 14px;color: #797979">单价:
              <span style="color: #000000;font-weight: bold">￥{{ item.TransactionPrice }}</span>
          </span>
            <span style="font-size: 14px;color: #797979;margin-left: 10px;">合计:
              <span style="color: #000000;font-weight: bold">￥{{ item.Amount }}</span>
          </span>
          </div>

        </div>
        <div class="orderProduct">
          <!--            产品图片-->
          <div v-if="item.ProductImgPath">
            <img style="width: 120px;height: 120px;" :src="formatPic(item.ProductImgPath)" alt/>
          </div>
          <div v-else>
            <div style="width: 87px;height: 87px;background: #f5f5f5"></div>
          </div>
          <!--            名称/所属库区-->
          <div class="orderState" style="justify-content: space-around;width: 250px">
            <div style="font-size: 18px;font-weight: bold">{{ item.ProductName }}</div>
            <div style="font-size: 14px;">售货单位：{{ item.WarehouseName }}</div>
            <div style="font-size: 14px;">预/实提量：{{ item.Quantity }} / {{item.DeliverAmount}}</div>
            <div style="font-size: 14px;display: flex">车牌号：
              <el-tooltip class="item" effect="dark" :content="item.TruckNos?item.TruckNos:'暂无车牌'" placement="bottom-start">
                <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 100px;display: inline-block">{{item.TruckNos?item.TruckNos:'暂无车牌'}}</span>
              </el-tooltip>
            </div>
          </div>
          <!--            状态-->
          <div class="orderState" style="width: 80px">
            <div v-if="item.OrderStatus == 0">
              <div class="StateInfo" style="color: red">
                <el-tag type="info" effect="dark">待支付</el-tag>
              </div>
              <!--                此处应为倒计时-->
              <!--                <div style="color: red"><i class="el-icon-loading"></i>1小时25分30秒</div>-->
            </div>
            <div v-else-if="item.OrderStatus == -3 || item.OrderStatus == -6">
              <div class="StateInfo" style="color: red">
                <el-tag effect="dark">同步中</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == 1">
              <div class="StateInfo" style="color: red">
                <el-tag type="success" effect="dark">已支付</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == 2 || item.OrderStatus == 5">
              <div class="StateInfo"><el-tag effect="dark">提货中</el-tag></div>

            </div>
            <div v-else-if="item.OrderStatus == -10">
              <div class="StateInfo">
                <el-tag type="danger" effect="dark">订单已关闭</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == 9 || item.OrderStatus == 8">
              <div class="StateInfo">
                <el-tag type="success" effect="dark">订单已完成</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == 7">
              <div class="StateInfo">
                <el-tag type="warning" effect="dark">订单提货截止</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == -2">
              <div class="StateInfo">
                <el-tag type="warning" effect="dark">支付超时</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == -5">
              <div class="StateInfo">
                <el-tag type="danger" effect="dark">创建失败</el-tag>
              </div>
            </div>
            <div v-else-if="item.OrderStatus == -1">
              <div class="StateInfo">
                <el-tag type="info" effect="dark">已关闭</el-tag>
              </div>
            </div>
          </div>
          <!--            按钮-->
          <div style="display: flex;align-items: center;width: 170px">
            <el-button type="text" size="small" @click="toDetail(item.OrderId)">订单详情</el-button>
            <el-button type="text" size="small" v-if="item.OrderStatus == 0" @click="toPay(item.OrderId)">立即支付</el-button>
            <el-button v-if="item.OrderStatus == 0" type="text" size="small" @click="toCancel(item.OrderId)">取消订单</el-button>
            <el-button v-if="item.OrderStatus == 1 || item.OrderStatus == 2 || item.OrderStatus == 5" type="text"
              size="small" @click="toFinished(item.OrderId)">完成
            </el-button>
            <el-button v-if="item.OrderStatus == -5 || item.OrderStatus == -1 || item.OrderStatus == -2" type="text" size="small" @click="toDelete(item.OrderId)">删除</el-button>
            <bill-button
              style="margin-left: 10px;"
              size="mini"
              v-if="(item.OrderStatus == 1 || item.OrderStatus == 2) &&  (item.Quantity - item.EstimateQuantity > 0)"
              @saved="onSavedBill"
              :order-id="item.OrderId"
            ></bill-button>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;align-items: center;height: 200px;font-size: 14px;color: grey"
         v-if="empty">
      暂无数据
    </div>
    <div class="block" v-if="TotalCount > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="TotalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script type="text/javascript">
import PayButton from "@/components/Buttons/PayButton";
import BillButton from "@/components/Buttons/CreateOrderBillButton";
import DelayButton from "@/components/Buttons/OrderDelayButton";
import Paging from "@/components/Table/Paging";
import DialogForm from "@/components/Dialogs/DialogForm";

export default {
  components: {
    BillButton,
    PayButton,
    Paging,
    DelayButton,
    DialogForm
  },
  props: {
    screen: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      // fenye
      empty: true,
      pageSize: 15,
      currentPage: 1,
      pageSizes: [15, 50, 100],
      TotalCount: 0,
      numData: {
        AllOrder: 0,
        Cancel: 0,
        Finish: 0,
        LadingFinish: 0,
        WaitLading: 0,
        WaitPay: 0,
        WaitSure: 0,
        Waiting: 0
      },
      dialogFormVisible: false,
      fullAllscreenLoading: false,
      times: [],
      order: [],
      url: {
        getNum: SZH.assets.api + "/Order/GetOrderStatusQuantity",
        get: SZH.assets.api + "/Order/GetPagingWebOrders",
        pay: SZH.assets.api + "/Order/OffProOrderToPay",
        pay2: SZH.assets.api + "/Order/OrderToPay",
        cancel: SZH.assets.api + "/Order/CloseOrder",
        sendPhoneVCodeOld: SZH.assets.api + "/Authen/SendVerifyCode2",
        GetOrderView: SZH.assets.api + "/Order/GetOrderView",
        commission: SZH.assets.api + "/Order/SaveOrderClient",
        loadCustom: SZH.assets.api + "/Order/GetSelectCustoms",
        SaveOrderClient: SZH.assets.api + "/Order/SaveOrderClient",
        CancleOrderClient: SZH.assets.api + "/Order/CancleOrderClient",
        payOrderContract: SZH.assets.api + "/Order/ContractOrderToPay",
        ModifyOrderPaymentType: SZH.assets.api + '/Order/ModifyOrderPaymentType',
        SubmitLadingModifyApply: SZH.assets.api + '/Order/SubmitLadingModifyApply',
        GetCustomCancelOrder: SZH.assets.api + '/Product/GetCustomCancelOrder',
        GetCurrentTime: SZH.assets.api + '/Test/GetTime',
        CancelOrder: SZH.assets.api + '/Order/CancelOrder',
        FinshOrder: SZH.assets.api + '/Order/FinshOrder',
        DeleteOrder: SZH.assets.api + '/Order/DeleteOrder',
      },
      sendCondUrl: SZH.assets.api + "/Order/OffProOrderToPay",
      params: {
        OrderStatus: "All", // 状态
        BeginTime: "",
        EndTime: "",
        Keyword: "" // 关键字
      },
      OrderStatusList: [
        {id: null, name: "全部"},
        {id: -3, name: "支付中"},
        {id: -5, name: "创建失败"},
        {id: -4, name: "余额不足"},
        {id: -8, name: "待生效"},
        {id: -2, name: "支付超时"},
        {id: -1, name: "已关闭"},
        {id: 0, name: "待支付"},
        {id: 1, name: "已支付"},
        {id: 2, name: "提货中"},
        {id: 7, name: "提货截止"},
        {id: 9, name: "已完成"}
      ],
      loading: false,
      visible: false,
      form: {
        Vcode: "",
        OrderNo: ""
      },
      form02: {
        orderId: "",
        clientId: "",
        phoneNum: ""
      },
      formLabelWidth: "120px",
      formTemplate: [
        {
          col: 24,
          label: "短信验证码",
          prop: "Vcode",
          type: "v-code",
          click: c => {
            this.sendVcode(c);
          }
        }
      ],
      rules: {
        Vcode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur"
          },
          {
            min: 6,
            max: 6,
            message: "短信验证码长度应为6个字符",
            trigger: "blur"
          }
        ]
      },
      uploading: false,
      orderData: {},
      OrderStatusNew: [
        {
          label: '全部',
          value: 'AllOrder'
        },
        {
          label: '违约订单',
          value: 'Violate'
        },
        {
          label: '被委托',
          value: 'CoverClient'
        },
        {
          label: '已委托',
          value: 'AlreadyClient'
        }
      ],
      SearchOrderStatus: '',
      DjsListOrder: [],


      fullscreenLoading: false,
      ticker: null,
      currentTime: '',
    };
  },
  methods: {
    toDelete(id){
      var self = this;
      self.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.DeleteOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    toFinished(id){
      var self = this;
      self.$confirm('确定要完成订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.FinshOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    toCancel(id){
      var self = this;
      self.$confirm('确定要取消订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.fullscreenLoading = true;
        self.$http.post(self.url.CancelOrder, {
          KeyValue: id
        }).then(result => {
          if (result.state == true) {
            self.$message({
              type: 'success',
              message:'操作成功'
            });
            self.GetPagingWebOrders()
          } else {
            self.$message({
              type: 'error',
              message: result.message
            });
          }
          self.fullscreenLoading = false;
        }, () => {
          self.fullscreenLoading = false;
        });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    toPay(id){
      this.$router.push({
        path:'/Menu/PayOrder',
        query:{
          OrderId:id
        }
      })
    },
    toDetail(id){
      this.$router.push({
        path:'/My/orderdetail',
        query:{
          id:id
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.GetPagingWebOrders()
    }
    ,
    handleCurrentChange(val) {
      this.currentPage = val
      this.GetPagingWebOrders()
    }
    ,
    GetPagingWebOrders() {
      let self = this;
      self.fullAllscreenLoading = true;
      self.$http.post(self.url.get, {
        Data: self.params,
        PageSize: self.pageSize,
        PageIndex: self.currentPage
      }).then(result => {
        if (result.state == true && result.data.Data && result.data.Data.length > 0) {
          self.order = result.data.Data;
          self.TotalCount = result.data.TotalCount;
          self.empty = false
        } else {
          self.order = [];
          self.$message.error(result.message?result.message:'未查询到数据');
          self.empty = true
        }
        self.fullAllscreenLoading = false;
      }, () => {
        self.fullAllscreenLoading = false;
      })
    },
    beforeSave() {
      this.uploading = true;
    },
    afterSaved() {
      this.uploading = false;
    },
    onSavedError() {
      this.uploading = false;
    },
    saveCode() {
      this.GetPagingWebOrders()
    },
    // 创建时间改变
    onParamsChange() {
      this.params.BeginTime = this.times[0].Date();
      this.params.EndTime = this.times[1].Date();
    },
    // 查询
    listSearch() {
      this.GetPagingWebOrders();
    },
    // 状态卡片切换
    handleClick() {
      this.GetPagingWebOrders()
    },
    onCannotpay() {
      this.GetPagingWebOrders()
    },
    onSavedBill() {
      this.GetPagingWebOrders()
    },
    toFixed(num) {
      return parseFloat(
        num != null && num != undefined ? num.toFixed(3) : "0.00"
      );
    },
    fomatDate(date) {
      var d = new Date(date);
      return d.format("yyyy-MM-dd");
    },
    fomatTime(date) {
      var d = new Date(date);
      return d.format("hh:mm:ss");
    },
    formatPic(path) {
      return SZH.assets.image + path;
    },
    cancel(id) {
      var self = this;
      self.$http
        .post(self.url.GetCustomCancelOrder, {
          Data: id
        })
        .then(
          result => {
            if (result.State == 1) {
              self.cancelLast(id, result.Data.CanCancelCount, result.Data.CancelledCount)
            } else {
              self.$message.error(result.Message);
            }
          },
          () => {
          }
        );
    },
    cancelLast(id, cancancle, cancled) {
      var self = this;
      self.$confirm('确定取消吗?当前已取消' + cancled + '次，最多可取消' + cancancle + '次', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.loading = true;
        self.$http
          .post(self.url.cancel, {
            Data: {
              OrderNo: id,
              CloseReason: "客户关闭订单"
            }
          })
          .then(
            result => {
              if (result.State == 1) {
                self.$message.success("订单关闭成功！");
                self.$refs["paging"].reload();
              } else {
                self.$message.error(result.Message);
              }
              self.loading = false;
            },
            () => {
            }
          );

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onCardChange() {
    },

    //  新增数组倒计时
    beginTimer() {
      //这个计时器是每秒减去数组中指定字段的时间

      this.ticker = setInterval(() => {

        for (let i = 0, len = this.OrderListNew.length; i < len; i++) {
          const item = this.OrderListNew[i];
          if (item.RefreshPriceDeadLineTime > 0) {
            item.RefreshPriceDeadLineTime = item.RefreshPriceDeadLineTime - 1000;
          }
        }

      }, 1000);
    },
    time(time) {
      //这个函数是每秒把时间重新计算下
      if (time > 0) {
        // let d = Math.floor(time / 1000 / 60 / 60 / 24);
        let h = Math.floor((time / 1000 / 60 / 60) % 24);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        // return d + "天" + h + "时" + m + "分" + s + "秒";
        return h + "时" + m + "分" + s + "秒";
      } else {
        return '';
      }
    },
    OrderDjsFun(dd) {
      if (dd) {
        for (let i = 0, len = dd.length; i < len; i++) {
          const item = dd[i];
          if (item.RefreshPriceDeadLineTime && (item.OrderStatus == 1 || item.OrderStatus == 2)) {
            item.RefreshPriceDeadLineTime = new Date(item.RefreshPriceDeadLineTime).getTime() - new Date(this.currentTime).getTime();
          }

        }
        this.OrderListNew = dd; //将改变后的数组赋值给自定义的数组 然后调用计时器 每秒减去指定字段的时间戳 -1000毫秒
        if (this.ticker) {
          //这一段是防止进入页面出去后再进来计时器重复启动
          clearInterval(this.ticker);
        }
        this.beginTimer();
      }

    },
    loaded(data) {
      this.OrderDjsFun(data);
    },
    getCurrentTimeFun() {
      this.$http.post(this.url.GetCurrentTime, {}).then(result => {
        this.currentTime = result.Now;
      }, () => {
      });

    }

  },
  computed: {

  },
  created() {
  },
  mounted() {
    this.GetPagingWebOrders();
  },
  watch: {}
};
</script>

<style type="text/css" scoped>
.table {
  width: 100%;
  font-size: 12px;
}

/*订单详情*/
.orderDetail {
  width: 100%;
  border: 1px solid #cccbcbc2;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 25px;
}

.orderProduct {
  display: flex;
  border-top: 1px solid #cccbcbc2;
  padding: 10px;
  justify-content: space-between;
}

.orderState {
  display: flex;
  justify-content: center;
  flex-direction: column;
  /*align-items: center;*/
}

.StateInfo {
  font-size: 16px;
  text-align: center;
}

.left {
  text-align: right;
}

/* 订单列表 */
.order-list-box {
  max-width: 1000px;
  margin: 0 auto;
}

.order-list-box .product-info {
  height: 80px;
  position: relative;
}

.product-info {
  white-space: normal;
}

.product-info > .img {
  height: 80px;
  width: 80px;
  float: left;
  position: relative;
}

.product-info > .img > img {
  height: 100%;
  width: 100%;
  position: absolute;
  right: 0;
  top: 0;
}

.product-info > .img > img.product-ticket {
  height: 30%;
  width: 30%;
}

.product-info > div {
  float: left;
  height: 80px;
  width: calc(100% - 80px);
  padding-left: 15px;
}

.product-info > div > p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  line-height: 21px;
}

.order-option {
  max-width: 100%;
  white-space: normal;
}

.order-option > .button {
  padding: 5px 2px;
  float: left;
  margin-left: 0 !important;
  margin-right: 5px;
}

.money-box {
  width: 100%;
  height: 130px;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  margin-bottom: 20px;
}

.money-box li {
  height: 100%;
  float: left;
  width: 25%;
  padding: 20px;
}

.money-box .money-box-num {
  font-size: 18px;
  color: #181818;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 10px;
  font-weight: 600;
}

.money-box .money-box-title {
  font-size: 14px;
  color: #999;
  text-align: center;
  padding-bottom: 10px;
  overflow: hidden;
}

.money-box p {
  font-size: 14px;
  color: #181818;
  text-align: center;
  overflow: hidden;
}

.block > .el-pagination {
  display: flex;
  justify-content: center;
}
</style>
<style>
/* 查询表单 */
#OrderStatus .el-form-item__content {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/OrderList/OrderList.vue